import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';

interface Props {
  onChange(): void;
  onClose(): void;
}

export const ChangeBucketCountModal = ({ onChange, onClose }: Props) => {
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: 'pld-edit--change-bucket-count-modal' }}
    >
      <ModalHeader as="h2" variant="warning" id="pld-edit--change-bucket-count-modal">
        Change the Asset Bucket&apos;s Number?
      </ModalHeader>

      <ModalBody>
        Changing the number of buckets resets position customizations and moves accounts from the
        reduced bucket to the unassigned category. Are you sure?
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          onClick={() => {
            onChange();
            onClose();
          }}
          ml="12"
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};
